/**
 * First-visit default locale: Portuguese-primary countries (IP) with
 * navigator language fallback, then English.
 * Does not read localStorage — caller should only invoke when no saved site language exists.
 *
 * US + English browser → `en` (use DEBUG_PRETEND_US_IS_PT in QA, or a PT browser locale, to get `pt`).
 */

const PT_PRIMARY_COUNTRIES = new Set([
  'BR',
  'PT',
  'AO',
  'MZ',
  'CV',
  'GW',
  'ST',
  'TL',
])

/** Set to `true` to default to PT from the US (first visit / cleared storage only). Set back to `false` after testing. */
const DEBUG_PRETEND_US_IS_PT = false

const GEO_URL = 'https://get.geojs.io/v1/ip/country.json'
const FETCH_TIMEOUT_MS = 5000

function localeFromNavigator() {
  if (typeof navigator === 'undefined') return 'en'
  const list =
    Array.isArray(navigator.languages) && navigator.languages.length
      ? navigator.languages
      : [navigator.language]
  for (const raw of list) {
    if (!raw) continue
    const first = String(raw).toLowerCase().split(/[-_]/)[0]
    if (first === 'pt') return 'pt'
  }
  return 'en'
}

export async function inferDefaultSiteLocale() {
  try {
    const ac = new AbortController()
    const timer = setTimeout(() => ac.abort(), FETCH_TIMEOUT_MS)
    const res = await fetch(GEO_URL, {
      signal: ac.signal,
      credentials: 'omit',
      cache: 'no-store',
    })
    clearTimeout(timer)
    if (!res.ok) return localeFromNavigator()
    const data = await res.json()
    const raw = data && (data.country != null ? data.country : data.code)
    const code = raw != null ? String(raw).toUpperCase() : ''
    if (
      code &&
      (PT_PRIMARY_COUNTRIES.has(code) ||
        (DEBUG_PRETEND_US_IS_PT && code === 'US'))
    ) {
      return 'pt'
    }
  } catch {
    /* use navigator fallback */
  }
  return localeFromNavigator()
}
